/**
 * @generated SignedSource<<3cfcefc5ca75bcd9a30a88857871ac90>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutSubmitButton_buyer$data = {
  readonly addressBook: {
    readonly addressList: ReadonlyArray<{
      readonly serviceId: string | null;
      readonly zipCode: string | null;
    } | null> | null;
  } | null;
  readonly profile: {
    readonly displayName: string | null;
    readonly email: string | null;
  } | null;
  readonly serviceId: string | null;
  readonly wallet: {
    readonly paymentMethods: ReadonlyArray<{
      readonly paymentMethod: {
        readonly __typename: string;
        readonly maskedCardNumber?: string | null;
        readonly paymentMethodTypeDisplay: string | null;
        readonly token?: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "CheckoutSubmitButton_buyer";
};
export type CheckoutSubmitButton_buyer$key = {
  readonly " $data"?: CheckoutSubmitButton_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutSubmitButton_buyer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutSubmitButton_buyer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Profile",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "preventEmailFallback",
              "value": true
            }
          ],
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": "displayName(preventEmailFallback:true)"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AddressBook",
      "kind": "LinkedField",
      "name": "addressBook",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Address",
          "kind": "LinkedField",
          "name": "addressList",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "zipCode",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Wallet",
      "kind": "LinkedField",
      "name": "wallet",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "WalletPaymentMethod",
          "kind": "LinkedField",
          "name": "paymentMethods",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "paymentMethod",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "token",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "maskedCardNumber",
                      "storageKey": null
                    }
                  ],
                  "type": "CreditCard",
                  "abstractKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "paymentMethodTypeDisplay",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "3de213e14a26e1abf10cf3fb37b922f3";

export default node;
